<template>
    <data-table
        additional-action-button-text="تنظیم محتوا جدول"
        additional-action-button-icon="vertical_split"
        show-select
        export-key="tickets"
        settings-key="tickets"
        @getList="getList"
        @click:additionalActionButton="ticketTableSettingsDialogRef.openDialog(settings)"
        ref="dataTableRef"
        :rowClick="(row) => router.resolve({path: `/tickets/${row.id}`})"
        :rowProps="(row) => Object.create({style: {'background-color': row.item.seen ? 'rgba(128, 128, 128, 0.08) !important' : ''}})"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :actions="actions"
        :additionalExports="additionalExports"
        :getAllList="getAllList"
    >
        <template #actionButton>
            <v-menu location="left" v-if="auth.user.employee && rbac.can('send ticket behalf customers') && system.license.features.ticket_send_behalf_customer">
                <template #activator="{ props }">
                    <v-btn v-bind="props" class="text-white" color="primary" >
                        <v-icon class="me-1" icon="add"></v-icon>تیکت جدید
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="router.push({path: '/tickets/new' })" link>
                        <v-list-item-title>ارسال تیکت</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="router.push({path: '/tickets/fromCustomer' })" link>
                        <v-list-item-title>ارسال تیکت از طرف مشتری</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn v-else :disabled="auth.user.expired" @click="router.push({path: '/tickets/new' })" class="text-white" color="primary" >
                <v-icon class="me-1" icon="add"></v-icon>تیکت جدید
            </v-btn>
        </template>
        <template #item.sla="{value}">
            <v-tooltip max-width="300" location="top">
                <template #activator="{ props }">
                    <div v-bind="props">
                        <i class="icon icon-16px icon-nosla" v-if="!value"></i>
                        <i class="icon icon-16px icon-srrfr" v-else-if="value.first_reply == 'failed' && value.resolve == 'failed'"></i>
                        <i class="icon icon-16px icon-srgfr" v-else-if="value.first_reply == 'failed' && value.resolve == 'passed'"><span class="icon path1"></span><span class="icon path2"></span></i>
                        <i class="icon icon-16px icon-srrfg" v-else-if="value.first_reply == 'passed' && value.resolve == 'failed'"><span class="icon path1"></span><span class="icon path2"></span></i>
                        <i class="icon icon-16px icon-srgfg" v-else-if="value.first_reply == 'passed' && value.resolve == 'passed'"></i>
                        <i class="icon icon-16px icon-srbfb" v-else-if="typeof value.first_reply == 'number' && typeof value.resolve == 'number'"></i>
                        <i class="icon icon-16px icon-srbfr" v-else-if="value.first_reply == 'failed' && typeof value.resolve == 'number'"><span class="icon path1"></span><span class="icon path2"></span></i>
                        <i class="icon icon-16px icon-srbfg" v-else-if="value.first_reply == 'passed' && typeof value.resolve == 'number'"><span class="icon path1"></span><span class="icon path2"></span></i>
                    </div>
                </template>
                <p v-if="!value">تیکت بدون SLA می‌باشد</p>
                <div v-else>
                    <p v-if="typeof value.first_reply == 'number'"><span class="text-primary me-1">ثبت اولین پاسخ: </span>{{ value.first_reply / 3600 >= 1 ? `${Math.floor(value.first_reply / 3600)} ساعت و ${Math.round(value.first_reply % 60)} دقیقه مانده` : `${Math.round(value.first_reply / 60)} دقیقه مانده` }}</p>
                    <p v-else><v-icon size="12" class="me-2" :color="value.first_reply == 'failed' ? 'error' : 'success'">{{ value.first_reply == 'failed' ? 'icon-close' : 'icon-check' }}</v-icon><span class="text-primary me-1">ثبت اولین پاسخ</span></p>
                    <p v-if="typeof value.resolve == 'number'"><span class="text-primary me-1">بسته شدن تیکت: </span>{{ value.resolve / 3600 >= 1 ? `${Math.floor(value.resolve / 3600)} ساعت و ${Math.round(value.resolve % 60)} دقیقه مانده` : `${Math.round(value.resolve / 60)} دقیقه مانده` }}</p>
                    <p v-else><v-icon size="12" class="me-2" :color="value.resolve == 'failed' ? 'error' : 'success'">{{ value.resolve == 'failed' ? 'icon-close' : 'icon-check' }}</v-icon><span class="text-primary me-1">بسته شدن تیکت</span></p>
                </div>
            </v-tooltip>
        </template>
        <template #item.pinned="{value, item}">
            <v-btn @click.stop="makeBookmark(item)" :icon="value ? 'bookmark' : 'bookmark_border'" color="primary" size="20" variant="text"></v-btn>
        </template>
        <template #item.importance="{value}">
            <v-chip :color="system.importances.find(x => x.name == value)?.color" variant="flat" class="text-small justify-center rounded" style="width: 100px;">{{value}}</v-chip>
        </template>
        <template #item.custom_fields="{value, item}">
            <span v-if="value.length == 0">-------</span>
            <v-btn v-else icon="icon-relatedarticles" color="primary" variant="text" @click.stop="customFields = value; identifier = item.identifier; customFieldShowRef.drawer = true"></v-btn>
        </template>
    </data-table>
    <custom-fields-show ref="customFieldShowRef" :title="`اطلاعات تکمیلی تیکت ${identifier}`" :customFields="customFields"></custom-fields-show>
    <ticket-table-settings-dialog ref="ticketTableSettingsDialogRef" :filtered-settings="filteredSettings" @updated="updateSettings"></ticket-table-settings-dialog>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useAuthStore } from '@/stores/auth';
import { useSystemStore } from '@/stores/system';
import { useConfirm } from '@/plugins/confirm/confirm';
import { useSocket } from '@/plugins/socket';
import { watch, onBeforeMount, useTemplateRef } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useLocalStorage } from '@vueuse/core';

defineOptions({
    title: 'تیکت ها',
});
const toast = useToastStore();
const globalLoading = useLoadingStore();
const api = useApi();
const router = useRouter();
const route = useRoute();
const confirm = useConfirm();
const socket = useSocket();
const moment = useMoment();
const system = useSystemStore();
const auth = useAuthStore();
const rbac = useRbac();
const dataTableRef = useTemplateRef('dataTableRef');
const customFieldShowRef = useTemplateRef('customFieldShowRef');
const ticketTableSettingsDialogRef = useTemplateRef('ticketTableSettingsDialogRef');
const customFields = ref([]);
const identifier = ref(null);
const additionalExports = ref({});
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const branchIds = auth.user.full_admin ? system.branches.map(x => x.id) : [auth.user.branch_id];
const settingsList = [
    {
        title: 'فقط نمایش تیکت‌های مشترک شده',
        key: 'only_mentioned',
        default: 0,
        permission: auth.user.employee
    },
    {
        title: 'فقط نمایش تیکت‌های من',
        key: 'self_tickets',
        default: 0,
        permission: auth.user.employee
    },
    {
        title: 'فقط نمایش تیکت‌های پایش شده',
        key: 'watched',
        default: 0,
        permission: auth.user.employee
    },
    {
        title: 'فقط نمایش تیکت‌های نشان شده',
        key: 'pinned',
        default: 0
    },
    {
        title: 'فقط نمایش تیکت‌های بازدید نشده',
        key: 'seen_tickets',
        default: 0
    },
    {
        title: 'نمایش تیکت‌های بازدید نشده در ابتدا',
        key: 'order_by_seen',
        default: 1
    },
];
const filteredSettings = computed(() => {
    return settingsList.filter(x => !Object.hasOwn(x, 'permission') || x.permission);
});
const settings = useLocalStorage('ticketTableContentSettings', Object.fromEntries(filteredSettings.value.map(x => [x.key, x.default])), { mergeDefaults: (storageValue, defaults) => Object.fromEntries(Object.keys(defaults).map(x => [x, Object.hasOwn(storageValue, x) ? storageValue[x] : defaults[x]])) });
const slaList = [
    { id: "0", name: "بدون SLA" },
    { id: "1", name: "ثبت به موقع اولین پاسخ" },
    { id: "2", name: "عدم ثبت به موقع اولین پاسخ" },
    { id: "3", name: "بسته شدن به موقع" },
    { id: "4", name: "عدم بسته شدن به موقع" },
    { id: "5", name: "دارای مهلت اولین پاسخ" },
    { id: "6", name: "دارای مهلت بسته شدن" },
    { id: "7", name: "گذشته از مهلت اولین پاسخ" },
    { id: "8", name: "گذشته از مهلت بسته شدن" },
];
const headers = ref([
    {
        title: '',
        key: 'pinned',
        minWidth: 25,
        filterable: false,
        sortable: false,
        exportable: false,
        removeable: false,
        hideInMobile: true,
    },
    {
        title: '',
        key: 'newTab',
        minWidth: 25,
        filterable: false,
        sortable: false,
        exportable: false,
        removeable: false,
        hideInMobile: true,
    },
    {
        title: 'شناسه',
        key: 'identifier',
        value: (item) => item.identifier,
        minWidth: 60,
    },
    {
        title: 'SLA',
        key: 'sla',
        minWidth: 40,
        align: 'center',
        filterable: false,
        sortable: false,
        exportable: false,
    },
    {
        title: 'اهمیت',
        key: 'importance',
        align: 'center',
        value: (item) => system.importances.find(x => x.id == item.importance).name,
        minWidth: 100,
        maxWidth: 100,
    },
    {
        title: 'دسته‌بندي',
        key: 'ticket_category',
        value: (item) => item.ticket_category?.name ?? 'سایر',
        minWidth: 160,
    },
    {
        title: 'محصول',
        key: 'service',
        value: (item) => item.service?.name ?? 'بدون محصول',
        minWidth: 160,
    },
    {
        title: 'وضعیت',
        key: 'ticket_status',
        value: (item) => system.ticketStatuses.find(x => x.id == item.ticket_status).name,
        minWidth: 95,
    },
    {
        title: 'عنوان',
        key: 'title',
        value: (item) => item.title,
        minWidth: 220,
    },
    {
        title: 'شعبه',
        key: 'branch_id',
        value: (item) => system.branches.find(x => x.id == item.branch_id).name,
        minWidth: 150,
        permission: auth.user.full_admin
    },
    {
        title: 'کاربر فرستنده',
        key: 'owner',
        value: (item) => item.owner ? item.owner.name : undefined,
        minWidth: 180,
        permission: auth.user.employee || auth.user.customer_information.supervisor,
    },
    {
        title: 'گروه فرستنده',
        key: 'from_department',
        value: (item) => item.from_department.id == system.customers_department.id && auth.user.employee ? "سازمان " + item.owner.customer_information.organization.name : item.from_department.name,
        minWidth: 170,
    },
    {
        title: 'کاربر گیرنده',
        key: 'recipient',
        value: (item) => item.recipient ? item.recipient.name : undefined,
        minWidth: 180,
        permission: auth.user.employee || auth.user.customer_information.supervisor,
    },
    {
        title: 'گروه گیرنده',
        key: 'to_department',
        value: (item) => item.to_department.id == system.customers_department.id && auth.user.employee ? "سازمان " + item.recipient.customer_information.organization.name : item.to_department.name,
        minWidth: 170,
    },
    {
        title: 'سطح مشتری',
        key: 'ticket_customer_level',
        value: (item) => item.from_department.id != system.customers_department.id ? item.to_department.id != system.customers_department.id ? undefined : item.recipient.customer_information.customer_level.name : item.owner.customer_information.customer_level.name,
        minWidth: 140,
        permission: auth.user.employee
    },
    {
        title: 'نام کاربری مشتری',
        key: 'ticket_customer_username',
        value: (item) => item.from_department.id != system.customers_department.id ? item.to_department.id != system.customers_department.id ? undefined : item.recipient.username : item.owner.username,
        minWidth: 180,
        permission: rbac.can('view customer information')
    },
    {
        title: 'ایمیل مشتری',
        key: 'ticket_customer_email',
        value: (item) => item.from_department.id != system.customers_department.id ? item.to_department.id != system.customers_department.id ? undefined : item.recipient.email : item.owner.email,
        minWidth: 230,
        permission: rbac.can('view customer information')
    },
    {
        title: 'شماره تماس مشتری',
        key: 'ticket_customer_mobile',
        value: (item) => item.from_department.id != system.customers_department.id ? item.to_department.id != system.customers_department.id ? undefined : item.recipient.mobile : item.owner.mobile,
        minWidth: 180,
        permission: rbac.can('view customer information')
    },
    {
        title: 'میزان رضایت مندی',
        key: 'satisfaction',
        value: (item) => system.satisfactionList.find(x => x.id == (item.satisfaction ?? 0)).name,
        minWidth: 150,
        permission: !auth.user.employee || auth.user.full_admin || auth.user.branch_admin || auth.user.department_admin
    },
    {
        title: 'فیلد های سفارشی',
        key: 'custom_fields',
        minWidth: 100,
        filterable: false,
        sortable: false,
        exportable: false,
        permission: system.license.features.customer_custom_field
    },
    {
        title: 'زمان ایجاد',
        key: 'created_at',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.created_at ? moment(item.created_at).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
    {
        title: 'آخرین به روزرسانی',
        key: 'updated_at',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.updated_at ? moment(item.updated_at).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
    },
    {
        title: 'مهلت اولین پاسخ',
        key: 'first_reply_duetime',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.first_reply_duetime ? moment(item.first_reply_duetime).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
        permission: auth.user.employee && system.license.features.ticket_sla,
    },
    {
        title: 'مهلت بسته شدن',
        key: 'resolve_duetime',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.resolve_duetime ? moment(item.resolve_duetime).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
        permission: auth.user.employee && system.license.features.ticket_sla,
    },
    {
        title: 'زمان اولین پاسخ',
        key: 'first_response_time',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.first_response_time ? moment(item.first_response_time).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
        permission: auth.user.employee,
    },
    {
        title: 'زمان بسته‌ شدن',
        key: 'final_resolve_time',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.ticket_status == '4' && item.final_resolve_time ? moment(item.final_resolve_time).format('jYYYY/jMM/jDD | HH:mm') : undefined,
        minWidth: 150,
        permission: auth.user.employee,
    },
    {
        title: 'مدت اولین پاسخ',
        key: 'response_time',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.first_response_time ? moment.duration(moment(item.first_response_time).diff(moment(item.created_at))).humanize() : undefined,
        minWidth: 150,
        permission: auth.user.employee,
    },
    {
        title: 'مدت بسته‌ شدن',
        key: 'resolve_time',
        cellProps: {style: 'direction: ltr; text-align: right'},
        value: (item) => item.ticket_status == '4' && item.final_resolve_time ? moment.duration(moment(item.final_resolve_time).diff(moment(item.created_at))).humanize() : undefined,
        minWidth: 150,
        permission: auth.user.employee,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس کلمه کلیدی', value: null },
    keyword: { type: 'text', label: 'عنوان', value: null },
    date_based: { type: 'divider', label: 'بر اساس تاریخ و ساعت', value: null },
    from_date: { type: 'date', label: 'تاریخ ایجاد', dateType: 'datetime', group: 'start', onChange: (value) => { filters.value.to_date.value = value > filters.value.to_date.value ? null : filters.value.to_date.value; filters.value.to_date.min = value; }, value: null },
    to_date: { type: 'date', label: 'تاریخ ایجاد', dateType: 'datetime', group: 'end', min: null, value: null },
    id_based: { type: 'divider', label: 'بر اساس شماره تیکت', value: null },
    from_id: { type: 'text', label: 'شماره...', group: 'start', value: null },
    to_id: { type: 'text', label: 'شماره...', group: 'end', value: null },
    department_based: { type: 'divider', label: 'بر اساس دپارتمان فرستنده / گیرنده', value: null },
    fdep: { type: 'autocomplete', multiple: true, label: 'دپارتمان فرستنده', items: auth.user.employee ? system.departments : [...auth.user.to_departments, system.customers_department], value: [] },
    tdep: { type: 'autocomplete', multiple: true, label: 'دپارتمان گیرنده', items: auth.user.employee ? system.departments : [...auth.user.to_departments, system.customers_department], value: [] },
    employee_based: { type: 'divider', label: 'بر اساس کاربر سازمانی', value: null, permission: auth.user.employee },
    ousr: { type: 'autocomplete', multiple: true, label: 'کاربر سازمانی فرستنده', items: [auth.user, ...auth.user.to_departments.filter((x) => x.users).map((x) => x.users).flat().filter((value, index, self) => self.findIndex((x) => x.id == value.id) == index)], value: [], permission: auth.user.employee },
    rusr: { type: 'autocomplete', multiple: true, label: 'کاربر سازمانی گیرنده', items: [auth.user, ...auth.user.to_departments.filter((x) => x.users).map((x) => x.users).flat().filter((value, index, self) => self.findIndex((x) => x.id == value.id) == index)], value: [], permission: auth.user.employee },
    customer_based: { type: 'divider', label: 'بر اساس مشتری', value: null, permission: auth.user.employee },
    customer_id: { type: 'customerSearch', label: 'کاربران', value: null, permission: auth.user.employee },
    customer_email: { type: 'text', label: 'ایمیل', value: null, permission: auth.user.employee && rbac.can('view customer information') },
    customer_mobile: { type: 'text', label: 'شماره موبایل', value: null, permission: auth.user.employee && rbac.can('view customer information') },
    customer_username: { type: 'text', label: 'نام کاربری', value: null, permission: auth.user.employee && rbac.can('view customer information') },
    customer_levels: { type: 'autocomplete', multiple: true, label: 'سطح مشتری', items: system.customerLevels, value: null, permission: auth.user.employee },
    oorg: { type: 'autocomplete', multiple: true, label: 'سازمان فرستنده', items: system.organizations, value: null, permission: auth.user.employee },
    rorg: { type: 'autocomplete', multiple: true, label: 'سازمان گیرنده', items: system.organizations, value: null, permission: auth.user.employee },
    ticketinfo_based: { type: 'divider', label: 'بر اساس اطلاعات تیکت', value: null },
    branches: { type: 'autocomplete', multiple: true, label: 'شعبه', items: system.branches, value: [], permission: auth.user.full_admin },
    ticket_statuses: { type: 'autocomplete', multiple: true, label: 'وضعیت تیکت', items: system.ticketStatuses, value: [] },
    importances: { type: 'autocomplete', multiple: true, label: 'اهمیت تیکت', items: system.importances, value: [] },
    cat: { type: 'autocomplete', multiple: true, label: 'دسته بندی موضوعی', items: [...system.ticketCategories, {id: 0, name: 'سایر'}], value: [] },
    services: { type: 'autocomplete', multiple: true, label: 'محصول', items: [...system.services, {id: 0, name: 'بدون محصول'}], value: [], permission: auth.user.employee },
    satisfactions: { type: 'autocomplete', multiple: true, label: 'میزان رضایت مندی', items: system.satisfactionList, value: [] },
    tags: { type: 'autocomplete', multiple: true, label: 'برچسب‌ها', items: system.tags, value: [], permission: auth.user.employee },
    custom_field_based: { type: 'divider', label: 'بر اساس فیلد های سفارشی', value: null, permission: system.license.features.customer_custom_field },
    custom_field_items: { type: 'autocomplete', label: 'فیلد های سفارشی', multiple: true, items: system.customFields, itemTitle: 'label', value: [], permission: system.license.features.customer_custom_field },
    custom_fields: { type: 'customFields', multiple: true, label: 'فیلد های سفارشی', items: [], value: [], permission: system.license.features.customer_custom_field },
    sla_based: { type: 'divider', label: 'بر اساس ویژگی های مشتری', value: null, permission: auth.user.employee && system.license.features.ticket_sla },
    sla: { type: 'autocomplete', label: 'وضعیت SLA', items: slaList, value: [], permission: auth.user.employee && system.license.features.ticket_sla },
});
const actions = ref([
    {
        title: 'تغییر وضعیت به بسته شده',
        icon: 'icon-closeticket',
        clicked: (selected) => makeMultipleClose(selected),
        enabled: (selected) => selected.length
    },
    {
        title: 'تغییر وضعیت به در حال انجام',
        icon: 'icon-pendding',
        clicked: (selected) => makeMultiplePending(selected),
        enabled: (selected) => selected.length
    },
]);
function makeMultipleClose(selected) {
    confirm(
        `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، تیکت${
            selected.length == 1
                ? ` شماره <b>${selected[0].identifier}</b>`
                : "‌های انتخاب شده"
        } بسته خواهد شد.</p>`
    ).then((res) => {
        if (res){
            globalLoading.start();
            api.multipleTicketAction({ action: 'close', ids: selected.map((x) => x.id)}).then(async (res) => {
                if (res && res.status == "UPDATED") {
                    getList(dataTableRef.value.finalFilters);
                    if (!res.data.failed.length) {
                        toast.success(res.message);
                    } else {
                        toast.warning("عملیات انجام شد اما امکان بسته شدن برخی از تیکت ها وجود نداشت.");
                    }
                }
            }).finally(()=>{ globalLoading.finish(); selected.value = [] });
        }
    });
}
function makeMultiplePending(selected) {
    confirm(
        `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید، وضعیت تیکت${
            selected.length == 1
                ? ` شماره <b>${selected[0].identifier}</b>`
                : "‌های انتخاب شده"
        } به در حال انجام تغییر خواهد کرد.</p>`
    ).then((res) => {
        if (res){
            globalLoading.start();
            api.multipleTicketAction({ action: 'pend', ids: selected.map((x) => x.id)}).then(async (res) => {
                if (res && res.status == "UPDATED") {
                    getList(dataTableRef.value.finalFilters);
                    if (!res.data.failed.length) {
                        toast.success(res.message);
                    } else {
                        toast.warning("عملیات انجام شد اما امکان تغییر وضعیت برخی از تیکت ها وجود نداشت.");
                    }
                }
            }).finally(()=>{ globalLoading.finish(); selected.value = [] });
        }
    });
}
function makeBookmark(item) {
    api.ticketUpdate(item.id, {pinned: !item.pinned, _method: 'put'}).then(res => {
        if (res && res.status == "UPDATED")
            item.pinned = !item.pinned;
    });
}
function updateSettings(newSettings) {
    let updateFlag = false;
    filteredSettings.value.forEach(el => {
        if (settings.value[el.key] !== newSettings[el.key]) {
            settings.value[el.key] = newSettings[el.key];
            updateFlag = true;
        }
    });
    if (updateFlag)
        getList(dataTableRef.value.finalFilters);
}
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.ticketList({
        ...settings.value,
        ...finalFilters
    }).then(async res => {
        if (res && res.status == 'OK') {
            items.value = res.data;
            totalItems.value = res.total;
            if (system.license.features.customer_custom_field)
                additionalExports.value = res.data.map(x => x.custom_fields).flat().filter((item, index, all) => all.findIndex(x => x.id == item.id) == index).reduce((res, item) => (res[item.label] = x => x.custom_fields.find(x => x.id == item.id) ? customFieldShowRef.value.getValue(x.custom_fields.find(x => x.id == item.id)) : undefined, res), {});
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.ticketList({
            ...settings.value,
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == 'OK') {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    if (system.license.features.customer_custom_field)
        additionalExports.value = data.map(x => x.custom_fields).flat().filter((item, index, all) => all.findIndex(x => x.id == item.id) == index).reduce((res, item) => (res[item.label] = x => x.custom_fields.find(x => x.id == item.id) ? customFieldShowRef.value.getValue(x.custom_fields.find(x => x.id == item.id)) : undefined, res), {});
    return data;
}
watch(filters.value.custom_field_items, () => {
    filters.value.custom_fields.items = system.customFields.filter(x => filters.value.custom_field_items.value.some(y => y == x.id));
});
onBeforeMount(() => {
    if (auth.user.employee)
        system.setTags().then(() => filters.value.tags.items = system.tags);
    branchIds.forEach(el => {
        socket.channel('ticketList.' + el).listen('ticketChangeEvent', () => {
            if (route.path == '/tickets') {
                if (filters.value.page.value == 1) getList(dataTableRef.value.finalFilters);
            } else {
                socket.leave('ticketList.' + el);
            }
        });
    });
});
onBeforeUnmount(() => {
    branchIds.forEach(el => {
        socket.leave('ticketList.' + el);
    });
})
</script>
